import React from 'react';
import './Page.css';
/* Pullstate Store */
import { UserStore } from '../store/UserStore';
import { PermitStore } from '../store/PermitStore';
import { IonInput, IonLabel } from '@ionic/react';

const ManualAddress = (props) => {
    const { context } = props;
    const userDoc = UserStore.useState((s) => s.userDoc);
    const application = PermitStore.useState((s) => s.application);

    console.log(context);
    const setAddress = (fullAddress) => {
        if (context === 'application') {
            PermitStore.update((s) => {
                s.application = { ...s.application, otherAddress: fullAddress };
            });
        }
        if (context === 'onboarding') {
            UserStore.update((s) => {
                s.userDoc = { ...s.userDoc, address: fullAddress, fullAddress: fullAddress };
            });
        }
        if (context === 'propertyOwner') {
            PermitStore.update((s) => {
                s.application = { ...s.application, propertyOwnerAddress: fullAddress };
            });
        }
    };
    return (
        <div className='ion-padding-horizontal'>
            <IonLabel className='onboardingLabels' position='stacked'>
                Enter {context === 'propertyOwner' ? `Property Owner's ` : null}Address
            </IonLabel>
            <IonInput
                type='text'
                autocapitalize='on'
                placeholder='Please enter the address here'
                className='onboardingInputs'
                enterkeyhint='next'
                inputmode='text'
                pattern='text'
                value={
                    context === 'onboarding' && userDoc.address
                        ? userDoc.address
                        : context === 'application'
                        ? application.otherAddress
                        : context === 'propertyOwner'
                        ? application.propertyOwnerAddress
                        : ''
                }
                onIonChange={(e) => {
                    setAddress(e.target.value);
                }}
            />
            <p className='ion-text-left'>
                <strong>Please note:</strong> By entering your address manually, your application
                may be subject to additional review by the Fire Department to confirm the location.
            </p>
        </div>
    );
};

export default ManualAddress;
